import { lazy } from "react";
import Redirect from "../Redirect";

const ControlPanel = lazy(() => import("../../layout"));
const Login = lazy(() => import("../../pages/Login"));

const pagesRoute = [
  {
    path: "/login",
    component: Login,
    meta: {
      redirectUrl: "/",
      protectedRoute: false,
      role: "",
    },
  },
  {
    path: "/",
    component: ControlPanel,
    meta: {
      redirectUrl: "/login",
      protectedRoute: true,
      role: "admin",
    },
  },
  {
    path: "*",
    component: Redirect,
    meta: {
      redirectUrl: "/",
      protectedRoute: false,
      role: "",
    },
  },
];
export default pagesRoute;
